// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__elomf","col":"styles_col__1rHvQ"};